export function getFilterForPreApprovedOrPrequalifyByParam(
  queryParam?: string
) {
  if (!queryParam) return { isPreapprovedClient: false };

  if (queryParam === 'true') return { isPreapprovedClient: true };
  if (queryParam === 'false') return { isPreapprovedClient: false };
  return { isPreapprovedClient: false };
}
